import { render, staticRenderFns } from "./StaffDefault.vue?vue&type=template&id=1dbb9a54&"
import script from "./StaffDefault.vue?vue&type=script&lang=js&"
export * from "./StaffDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports